import { cn } from '@/lib/utils';

interface EmailLinkProps {
  email: string;
  className?: string;
}

function EmailLink({ email, className }: EmailLinkProps) {
  return (
    <a
      href={`mailto:${email}`}
      className={cn('text-text-link hover:text-text-link-hovered hover:underline', className)}
    >
      {email}
    </a>
  );
}

export { EmailLink };
